import styles from './CourseAdoptionTable.module.css';

const courses = [
  { course: 'Physics 1 series', department: 'Physics & Astronomy' },
  { course: 'Chemistry 14 series', department: 'Chemistry & Biochemistry' },
  { course: 'Chemistry 20 series', department: 'Chemistry & Biochemistry' },
  { course: 'LS 30A', department: 'Life Sciences Core' },
];

export function CourseAdoptionTable() {
  return (
    <div className={styles.card}>
      <table className={styles.table}>
        <caption>Courses adopting AIMS, 2025-2027</caption>
        <thead>
          <tr>
            <th scope="col">Course</th>
            <th scope="col">Department</th>
          </tr>
        </thead>
        <tbody>
          {courses.map((course) => (
            <tr key={course.course}>
              <td>{course.course}</td>
              <td>{course.department}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className={styles.note}>
        Expansion funded by UCLA&apos;s Teaching and Learning Center. Per the
        CEILS program description, instructors using the tools in subsequent
        iterations face minimal additional implementation labor.
      </p>
    </div>
  );
}
